__turbopack_context__.v({
  "container": "TrustBadges-module__K8BBRG__container",
  "description": "TrustBadges-module__K8BBRG__description",
  "icon": "TrustBadges-module__K8BBRG__icon",
  "item": "TrustBadges-module__K8BBRG__item",
  "section": "TrustBadges-module__K8BBRG__section",
  "title": "TrustBadges-module__K8BBRG__title",
});
